"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonThemeableRules = exports["default"] = void 0;
// Setting up nonThemeableRules for use within the React component generator
var nonThemeableRules = {
  packageName: 'SourceSystemIcons',
  colorAppliesTo: 'stroke',
  strokeWidth: '1px',
  defaultSize: 3,
  hasNumberBadge: true,
  size: {
    1: {
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16
    },
    2: {
      sm: 20,
      md: 20,
      lg: 20,
      xl: 20
    },
    3: {
      sm: 20,
      md: 24,
      lg: 24,
      xl: 24
    },
    4: {
      sm: 24,
      md: 32,
      lg: 32,
      xl: 32
    },
    5: {
      sm: 32,
      md: 36,
      lg: 36,
      xl: 36
    }
  },
  backgroundSize: {
    1: {
      sm: 32,
      md: 32,
      lg: 32,
      xl: 32
    },
    2: {
      sm: 36,
      md: 36,
      lg: 36,
      xl: 36
    },
    3: {
      sm: 36,
      md: 40,
      lg: 40,
      xl: 40
    },
    4: {
      sm: 40,
      md: 48,
      lg: 48,
      xl: 48
    },
    5: {
      sm: 48,
      md: 52,
      lg: 52,
      xl: 52
    }
  },
  appearance: {
    primary: {
      inverse: {}
    },
    secondary: {
      inverse: {}
    }
  },
  state: {
    success: {},
    error: {},
    info: {},
    warn: {}
  }
};
exports.nonThemeableRules = nonThemeableRules;
var ruleSet = function ruleSet(theme) {
  // deep clone the nonThemeableRules to modify them in side this function
  var rules = JSON.parse(JSON.stringify(nonThemeableRules)); // Applying themeable rules

  rules.appearance = {
    primary: {
      color: theme.color.monochrome6["default"],
      inverse: {
        color: theme.inverseColor.monochrome6["default"]
      }
    },
    secondary: {
      color: theme.color.primary1["default"],
      inverse: {
        color: theme.inverseColor.primary1["default"]
      }
    }
  };
  rules.state = {
    success: {
      color: theme.color.success["default"]
    },
    error: {
      color: theme.color.error["default"]
    },
    info: {
      color: theme.color.info["default"]
    },
    warn: {
      color: theme.color.warn["default"]
    }
  };
  return rules;
};
var _default = ruleSet;
exports["default"] = _default;